export default __webpack_public_path__ + "static/media/rangeAbsent.cd7c8685.svg";